import type { Account, Transaction } from "../types";
import { isCard, isExpense, isIncome } from "./finance";
import { roundToCents } from "./money-math";

/** Actual cash/debt movement, independent of household reportable shares. */
export function accountMovementMinor(account: Account, transaction: Transaction): number {
  const sign = isCard(account) ? -1 : 1;
  let movement = 0;
  if (transaction.toAccountId) {
    if (transaction.accountId === account.id)
      movement -= sign * (roundToCents(transaction.amount) + roundToCents(transaction.fee || 0));
    if (transaction.toAccountId === account.id)
      movement += sign * roundToCents(transaction.receivedAmount || 0);
  } else if (transaction.accountId === account.id) {
    if (isExpense(transaction)) movement -= sign * roundToCents(transaction.amount);
    if (isIncome(transaction)) movement += sign * roundToCents(transaction.amount);
  }
  return movement;
}

/** New SQL windows carry sparse month closes; empty months use the preceding close.
 * Older caches retain the original reverse-later-movements fallback. */
export function accountBalanceAtMonthEnd(account: Account, transactions: Transaction[], month: string): number {
  if (account.monthEndBalances) {
    const latest = Object.keys(account.monthEndBalances).filter(m => m <= month).sort().at(-1);
    return latest ? account.monthEndBalances[latest] : account.openingBalance ?? account.balance;
  }
  let balance = roundToCents(account.balance);
  for (const transaction of transactions) {
    if (transaction.date.slice(0, 7) > month) balance -= accountMovementMinor(account, transaction);
  }
  return balance / 100;
}
